import { render, staticRenderFns } from "./AreaChart.vue?vue&type=template&id=4f18ca7c&scoped=true"
import script from "./AreaChart.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AreaChart.vue?vue&type=style&index=0&id=4f18ca7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f18ca7c",
  null
  
)

export default component.exports